import { Stack, styled } from '@mui/material'
import { tokens } from 'ComponentLibrary'
import type { ReactNode } from 'react'

export const ValuationWizardLayout = ({
    stepper,
    children,
    maxWidth = '760px',
}: {
    stepper: ReactNode
    children: ReactNode
    maxWidth?: string
}) => (
    <WizardBackground>
        <WizardContent sx={{ maxWidth }}>
            {stepper}
            <WizardStepContent>{children}</WizardStepContent>
        </WizardContent>
    </WizardBackground>
)

const WizardBackground = styled(Stack)(() => ({
    width: `calc(100% + ${tokens.SizingSpacing600})`,
    // 820px shell minus the 73px Piazza header, capped by its 48px viewport margin.
    minHeight: 'min(747px, calc(100vh - 121px))',
    margin: `-${tokens.SizingSpacing300}`,
    padding: tokens.SizingSpacing300,
    boxSizing: 'border-box',
    alignItems: 'center',
    backgroundColor: tokens.ColorBackgroundDark,
    overflow: 'hidden',
}))

const WizardContent = styled(Stack)(() => ({
    width: '100%',
    height: '100%',
    minHeight: 0,
    alignItems: 'center',
}))

const WizardStepContent = styled(Stack)(() => ({
    width: '100%',
    flexGrow: 1,
    minHeight: 0,
    overflow: 'auto',
}))
